<template>
  <v-container>
    <v-row>
      <v-col xs="12" sm="12" md="4" lg="3">
        <UserNavigation />
      </v-col>
      <v-col xs="12" sm="12" md="8" lg="9">
        <v-toolbar color="secondary" dark height="45" rounded>
          <v-toolbar-title class="text-body-1">
            <v-icon>mdi-account-multiple-plus</v-icon>
            {{ $t("PANEL.USERGROUP.TITLE") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-container>
            <v-row class="px-3">
              <h3 class="mb-4 black--text text--darken-5">
                <v-icon left>mdi-account-convert</v-icon>
                {{ $t("PANEL.USERGROUP.SUBTITLE") }}
              </h3>
              <v-col cols="12" sm="12" lg="12" class="py-0">
                <v-text-field
                  v-model="groupName"
                  :label="$t('PANEL.USERGROUP.GROUP_NAME_LABEL')"
                  prepend-icon="mdi-card-account-details-outline"
                  :hint="$t('PANEL.USERGROUP.GROUP_NAME_HINT')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="12" class="py-0">
                <v-textarea
                  v-model="groupDesc"
                  prepend-icon="mdi-text-account"
                  name="input-7-1"
                  :label="$t('PANEL.USERGROUP.GROUP_DESC_LABEL')"
                  auto-grow
                  :hint="$t('PANEL.USERGROUP.GROUP_DESC_HINT')"
                  persistent-hint
                ></v-textarea>
              </v-col>
              <v-col></v-col>
              <v-col sm="12" lg="12" v-show="groupName">
                <h3 class="mb-2 black--text text--darken-5">
                  <v-icon left>mdi-account-convert</v-icon>
                  {{ $t("PANEL.USERGROUP.GROUP_ADD_ROLE_TITLE") }}
                </h3>
                <p class="caption pl-9">{{ $t("PANEL.USERGROUP.GROUP_ADD_ROLE_SUBTITLE") }}</p>
                <v-card-text v-for="(roleList, roleTop) in userRolesList" :key="roleTop">
                  <h3 class="mb-2 grey--text text--darken-2">
                    <v-icon left>mdi-script-outline</v-icon>
                    {{ roleTop }}
                  </h3>

                  <v-chip-group v-model="rolesList[roleTop]" column multiple @change="selectedChips(roleTop, $event)">
                    <v-chip
                      active-class="green white--text"
                      v-for="(role, key) in roleList"
                      :key="key"
                      :value="role.roleid"
                      @input="chipClicked"
                      @change="chipChanged(roleTop, role.roleid)"
                    >
                      <v-icon left v-if="isActiveChip(roleTop, role.roleid)">mdi-check</v-icon>
                      <v-icon left v-else>mdi-minus</v-icon>
                      {{ role.rolename }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-col>
              <v-col cols="12" v-if="!groupSysName" v-show="groupName">
                <v-btn color="accent" elevation="2" :loading="loadingStatus" @click="addNewGroup">
                  <v-icon>mdi-account-check</v-icon>
                  {{ $t("PANEL.USERGROUP.ADD_GROUP_BTN") }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-else v-show="groupName">
                <v-btn dark class="mr-3" color="green darken-1" elevation="2" :loading="loadingStatus" @click="editGroup">
                  <v-icon>mdi-account-check</v-icon>
                  {{ $t("PANEL.USERGROUP.EDIT_GROUP_BTN") }}
                </v-btn>
                <v-btn dark color="red darken-4" elevation="2" :loading="loadingStatus" @click="editGroupCancel">
                  <v-icon>mdi-account-check</v-icon>
                  {{ $t("PANEL.USERGROUP.CANCEL_GROUP_BTN") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <div class="my-5"></div>
        <v-toolbar color="secondary" dark height="45" rounded>
          <v-toolbar-title class="text-body-1">
            <v-icon>mdi-text-account</v-icon>
            {{ $t("PANEL.USERGROUP.LIST_TITLE") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-container>
            <v-row>
              <v-col sm="12" lg="12" class="py-0">
                <v-list class="py-0">
                  <v-list-item v-show="groupsList.errMessage">
                    <v-list-item-content>
                      <v-list-item-title class="body-1 text-center grey--text text--darken-2">
                        <v-icon left>mdi-information-outline</v-icon>
                        {{ groupsList.errMessage }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-show="!groupsList.errMessage" v-for="(group, key) in groupsList" :key="key">
                    <v-list-item-icon>
                      <v-icon left color="success">mdi-account-group</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 mb-1">{{ group.name }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption">
                        {{ group.desc }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="group.sysname !== 'yonetici'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn fab small elevation="0" color="#ddd" v-bind="attrs" v-on="on" @click="getGroupDetail(group.sysname)">
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("PANEL.USERGROUP.LIST_ACTION_EDIT") }}</span>
                      </v-tooltip>
                    </v-list-item-action>
                    <v-list-item-action v-if="group.sysname !== 'yonetici'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-on:hover="btnHover(this)" fab small elevation="0" color="#ddd" v-bind="attrs" v-on="on" @click="deleteGroupDialog(group.sysname)">
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("PANEL.USERGROUP.LIST_ACTION_DELETE") }}</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="groupDeleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("PANEL.USERGROUP.LIST_DELETE_DIALOG_TITLE") }}
        </v-card-title>
        <v-card-text v-html="$t('PANEL.USERGROUP.LIST_DELETE_DIALOG_CONTENT')"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="groupDeleteDialog = false">
            {{ $t("PANEL.USERGROUP.LIST_DELETE_DIALOG_ACTION_CANCEL") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="groupDeleteLoading" @click="deleteGroup()">
            {{ $t("PANEL.USERGROUP.LIST_DELETE_DIALOG_ACTION_YES") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UserNavigation from "@/components/Settings/UserOperations/UserNavigation";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "UserGroups",
  data() {
    return {
      groupName: "",
      groupDesc: "",
      rolesList: {},
      groupSysName: "",
      groupDeleteDialog: false,
      groupDeleteSysName: "",
      groupDeleteLoading: false,
      iconClicks: []
    };
  },

  computed: {
    loadingStatus() {
      return this.$store.state.User.UserGroups.loadingStatus;
    },
    groupsList() {
      return this.$store.getters.getUserGroupsList;
    },
    userRolesList() {
      return this.$store.getters.getUserRolesList;
    },
    ...mapState({
      userRolesList: state => state.User.UserRoles.rolesList
    }),
    ...mapGetters({
      groupsList: "User/UserGroups/getUserGroupsList"
    })
  },

  methods: {
    btnHover(e) {
      e;
    },
    rolesListSet() {
      /**
       * Role listesini kullanılabilir bir biçim için ayarla
       */
      this.rolesList = {};
      Object.keys(this.userRolesList).forEach(roleTop => {
        this.rolesList[roleTop] = [];
      });
    },
    addNewGroup() {
      const { groupName, groupDesc, rolesList } = this;
      this.$store
        .dispatch("User/UserGroups/addNewGroup", {
          groupName,
          groupDesc,
          rolesList
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("PANEL.USERGROUP.USERGROUP_NEW_GROUP_INSERT_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.resetGroupForm();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        });
    },
    editGroup() {
      const { groupSysName, groupName, groupDesc, rolesList } = this;
      this.$store
        .dispatch("User/UserGroups/editUserGroup", {
          groupSysName,
          groupName,
          groupDesc,
          rolesList
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("PANEL.USERGROUP.USERGROUP_NEW_GROUP_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.resetGroupForm();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        });
    },
    editGroupCancel() {
      this.resetGroupForm();
    },
    getGroupDetail(groupSysName) {
      /**
       * İlgili grubun detayını getir ve içe aktar
       */
      this.$store.dispatch("User/UserGroups/getGroupDetail", groupSysName).then(res => {
        if (res.status === 200) {
          const groupData = res.data;
          this.groupName = groupData.name;
          this.groupDesc = groupData.desc;
          this.rolesList = groupData.rolesList;
          this.groupSysName = groupData.sysname;
        }
      });
    },
    deleteGroupDialog(groupSysName) {
      this.groupDeleteDialog = true;
      this.groupDeleteSysName = groupSysName;
    },
    resetGroupForm() {
      this.groupName = "";
      this.groupDesc = "";
      this.rolesListSet();
      this.groupSysName = "";
    },
    deleteGroup() {
      this.groupDeleteLoading = true;
      this.$store.dispatch("User/UserGroups/deleteUserGroup", this.groupDeleteSysName).then(res => {
        if (res.status === 200) {
          this.$snotify.success(this.$t("PANEL.USERGROUP.USERGROUP_NEW_GROUP_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          this.resetGroupForm();
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.groupDeleteDialog = false;
        this.groupDeleteLoading = false;
      });
    },
    chipClicked(deger) {
      return deger;
    },
    chipChanged(roleTop, deger) {
      roleTop;
      deger;
    },
    selectedChips(roleTop, values) {
      this.$set(this.iconClicks, roleTop, values);
    },
    isActiveChip(roleTop, deger) {
      if (typeof this.iconClicks[roleTop] !== undefined && Object.keys(this.iconClicks).length > 0) {
        var degerAra = _.find(this.iconClicks[roleTop], o => {
          return o === deger;
        });
        if (degerAra) {
          return true;
        } else return false;
      }
      return false;
    }
  },
  components: {
    UserNavigation
  },
  beforeMount() {
    /**
     * Kullanıcı grupları listesini dispatch et
     */
    this.$store.dispatch("User/UserGroups/getUserGroups");

    /**
     * Rol Listesini Getir
     */
    this.$store.dispatch("User/UserRoles/getRolesList").then(() => {
      this.rolesListSet();
    });
  }
};
</script>
